import noop from 'lodash/noop';
import React, { PropsWithChildren } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import {
  Box,
  Button,
  CloseIcon,
  Divider,
  Spacing,
  styled,
  Typography,
} from 'ui';
import { useAuth } from '@context/AuthContext';
import { useFullScreenLayoutConfig } from '@context/FullScreenLayoutContext';
import { UserOrgCaseProvider } from '@context/UserOrgCaseContext';
import { PATHS } from '@utils/paths';

const StyledFullScreenLayout = styled('div')`
  height: 100%;
`;

const StyledHeader = styled('header')`
  display: flex;
  height: ${({ theme }) => theme.spacing(Spacing.Huge)};
  align-items: center;
  padding: ${({ theme }) => `0 ${theme.spacing(Spacing.Medium)}`};
  background-color: ${({ theme }) => theme.palette.background.paper};
`;

const StyledButton = styled(Button)`
  gap: ${({ theme }) => theme.spacing(1)};
`;

export function FullScreenLayout({ children }: PropsWithChildren) {
  const { isAuthenticated } = useAuth();
  const { pathname, search } = useLocation();
  const {
    config: {
      showCloseButton = true,
      headerButtons = null,
      onClose = () => noop,
    },
  } = useFullScreenLayoutConfig();

  if (!isAuthenticated) {
    return (
      <Navigate
        state={{ previousUrl: `${pathname}${search}` }}
        to={PATHS.PUBLIC.login}
      />
    );
  }

  return (
    <UserOrgCaseProvider>
      <StyledFullScreenLayout>
        <StyledHeader>
          <Box>
            {showCloseButton ? (
              <StyledButton color="neutral" onClick={onClose} variant="text">
                <CloseIcon />
                <Typography variant="subtitle">Close</Typography>
              </StyledButton>
            ) : null}
          </Box>
          {headerButtons ? headerButtons : null}
        </StyledHeader>
        <Divider noMargin />
        {children}
      </StyledFullScreenLayout>
    </UserOrgCaseProvider>
  );
}
